const KEY_SYSTEM = 'com.widevine.alpha';
const CONTENT_TYPE = 'video/mp4; codecs="avc1.42E01E"';

// Ordered from highest to lowest security level
const WIDEVINE_ROBUSTNESS_LEVELS = [
  'HW_SECURE_ALL', // L1: hardware TEE for decode + crypto
  'HW_SECURE_DECODE', // L2: hardware decode, software crypto
  'HW_SECURE_CRYPTO', // L2: hardware crypto, software decode
  'SW_SECURE_DECODE', // L3: software decode
  'SW_SECURE_CRYPTO', // L3: software crypto only
  '', // Basic: no robustness requirement
];

export type DrmSupportResult = {
  [level: string]: boolean | string | null;
  highestLevel: string | null;
};

export default async function probeDrmSupport(): Promise<DrmSupportResult> {
  const support: { [level: string]: boolean } = {};

  for (const robustness of WIDEVINE_ROBUSTNESS_LEVELS) {
    const key = robustness || 'basic';
    try {
      await navigator.requestMediaKeySystemAccess(KEY_SYSTEM, [
        {
          initDataTypes: ['cenc'],
          videoCapabilities: [{ contentType: CONTENT_TYPE, robustness }],
        },
      ]);
      support[key] = true;
    } catch {
      support[key] = false;
    }
  }

  const highestLevel =
    WIDEVINE_ROBUSTNESS_LEVELS.find((level) => support[level || 'basic'] === true) ?? null;

  return { ...support, highestLevel };
}
